<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.quiz.create")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineQuizForm :quiz="quiz" :APIbaseURL="APIbaseURL" />
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular indeterminate :size="100" :width="10" color="secondary"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import AveineQuizForm from '@/components/AveineQuizForm.vue'
import Quiz from '@/store/models/quiz'

export default {
  name: 'Create',
  components: { AveineQuizForm },
  data () {
    return {
      quiz: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  async created () {
    // `Model.new()` insere un enregistrement local et lui donne un id en `$uid`.
    // C'est cet id qui devient un `lid` a la serialisation : sans lui, le
    // serialiseur de la toolbox plante sur `data.id.charAt()`.
    this.quiz = await Quiz.new()
    this.quiz.$isNew = true
    // Traductions initialisees ici : le v-model du formulaire ecrirait sinon
    // dans un undefined.
    this.quiz.theme = {}
    this.quiz.question = {}
    this.quiz.explanation = {}
    this.quiz.answers = []
    this.dataLoaded = true
  }
}
</script>
